import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';

// stores
import useUIStore from '~/stores/ui';

export default defineNuxtPlugin(() => {
  const headerOffset = ref(0);

  const calculateOffset = (): number => {
    if (typeof window === 'undefined') return 0;

    let totalOffset = 0;

    const headerEl = document.querySelector(
      '[data-component-name="TheHeader"]',
    );

    if (headerEl instanceof HTMLElement) {
      totalOffset = headerEl.offsetHeight;
    }

    const bannerWrapper = document.getElementById('wrapper-banner');

    if (bannerWrapper?.classList.contains('visible')) {
      const bannerEl = bannerWrapper.querySelector(
        '[data-component-name="BreakingNewsBanner"]',
      );

      if (bannerEl instanceof HTMLElement) {
        totalOffset += bannerEl.offsetHeight;
      }
    }

    return totalOffset;
  };

  const { shouldDisplayBreakingNewsBanner } = storeToRefs(useUIStore());

  watch(
    shouldDisplayBreakingNewsBanner,
    async () => {
      await nextTick();
      headerOffset.value = calculateOffset();
    },
    { immediate: true },
  );

  return {
    provide: {
      headerOffset,
    },
  };
});
